'use client';

import runOnce from '@/utils/runOnce';
import initAvo from 'analytics/initAvo';

// Wrap this in the runOnce helper so that it only run once
const initAnalytics = runOnce(() => {
  initAvo();
});

initAnalytics();

// This is a dummy component that is used to initialize any analytics scripts
// on the client if unable to use the Script component from Next, e.g. if they
// rely on third party npm modules.
const InitAnalytics = () => null;

export default InitAnalytics;
